import React, { useState } from 'react';
import cn from 'classnames';
import style from './accordion.mod.scss';
import MinusIcon from '../global/icons/minus';
import PlusIcon from '../global/icons/plus';
import { Collapse } from '@mui/material';
import Container from '../layout/container/container';
import Text from '../text/text';
import Heading from '../heading/heading';

const Accordion = ({ items, openFirst = false}) => {
  const classes = cn(style.accordion);

  return (
    <div className={classes}>
      <Container size="lg">
        <div className={style.accordion__wrapper}>
          <div className={style.accordion__item}>
            {items.map((item, i) => (
              <AccordionItem
                {...item}
                key={item.id}
                itemNo={i}
                openFirst={openFirst}
              />
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

const AccordionItem = ({ heading, text, itemNo, openFirst }) => {
  const [isOpen, setIsOpen] = useState(openFirst ? itemNo === 0 : false);

  return (
    <>
      <div
        className={style.accordion__heading}
        onClick={() => setIsOpen(!isOpen)}
        role='button'
        tabIndex={0}
      >
        <Heading text={heading} size={'md'} tag={6} />
        <div className={style.accordion__icon}>
          {isOpen ? <MinusIcon /> : <PlusIcon />}
        </div>
      </div>
      <div className={style.accordion__content}>
        <Collapse in={isOpen}>
            <Text html={text} />
        </Collapse>
      </div>
    </>
  );
};

export default Accordion;
